var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MenuPromotion'),_c('Promotion_product_exp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }